import api from "./api";
import { buildOtherSurfaceQueryParams } from "helpers/VolSurface/otherSurfaceStrikeGraphs";

const VOL_SURFACE_END_POINT = "/vol-surface";

//// DELTA SURFACES APIs ////
const DELTA_SURFACES_END_POINT = `${VOL_SURFACE_END_POINT}/delta-surfaces`;
const GET_TABLE_ROWS_END_POINT = `${DELTA_SURFACES_END_POINT}/get-table-rows`;
const GRAPHS_END_POINT = `${DELTA_SURFACES_END_POINT}/graphs`;
const SURFACE_3D_END_POINT = `${DELTA_SURFACES_END_POINT}/surface-3d`;
const UPDATE_BATCH_END_POINT = `${DELTA_SURFACES_END_POINT}/update-batch`;
const GRAPHS_FILTER_END_POINT = `${GRAPHS_END_POINT}/filters`;
const SHORTCUTS_END_POINT = `${DELTA_SURFACES_END_POINT}/shortcuts`;
const GET_SURFACES_WITH_SMILES_ERRORS_END_POINT = `${DELTA_SURFACES_END_POINT}/get-surfaces-with-smiles-errors`;
const EXPORT_DATE_END_POINT = `${DELTA_SURFACES_END_POINT}/export-date`;
const SURFACES_END_POINT = `${DELTA_SURFACES_END_POINT}/surfaces`;
const STORE_DELTA_SURFACE_END_POINT = `${DELTA_SURFACES_END_POINT}/store`;
const SET_LIVE_END_POINT = `${DELTA_SURFACES_END_POINT}/set-live`;
const DELTA_CONTROL_TABLE_END_POINT = `${DELTA_SURFACES_END_POINT}/control-table`;
const VOL_CALC_TABLE_END_POINT = `${DELTA_CONTROL_TABLE_END_POINT}/vol-calc-table`;
const VOL_COMPARISON_END_POINT = `${DELTA_SURFACES_END_POINT}/vol-comparison`;
const VOL_COMPARISON_SHORTCUTS_END_POINT = `${VOL_COMPARISON_END_POINT}/shortcuts`;
const VOL_COMPARISON_PREVIEW_END_POINT = `${VOL_COMPARISON_END_POINT}/preview`;
const VOL_COMPARISON_SEND_END_POINT = `${VOL_COMPARISON_END_POINT}/send`;
const VOL_COMPARISON_MIN_ACCUMULATED_QTY_END_POINT = `${VOL_COMPARISON_END_POINT}/min-accumulated-qty`;
const BROKING_COMPANIES_END_POINT = `/trader/broking-companies`;
const  TRADER_SHORTCUTS_END_POINT = `/trader/shortcuts`;
const GET_LAST_EOD_SURFACES_FOR_SHORTCUTS_END_POINT = `${VOL_SURFACE_END_POINT}/get-last-eod-surfaces-for-shortcuts`;
const SEND_SFTP_FILE_END_POINT = `${VOL_SURFACE_END_POINT}/send-sftp`;

//// STRIKE SURFACES APIs ////
const STRIKE_SURFACES_END_POINT = `${VOL_SURFACE_END_POINT}/strike-surfaces`;
const STRIKE_GRAPHS_END_POINT = `${STRIKE_SURFACES_END_POINT}/graphs`;
const STRIKE_CONTROL_TABLE_END_POINT = `${STRIKE_SURFACES_END_POINT}/control-table`;
const STORE_STRIKE_CONTROL_TABLE_END_POINT = `${STRIKE_CONTROL_TABLE_END_POINT}/store`;
const UPDATE_STRIKE_CONTROL_TABLE_END_POINT = `${STRIKE_CONTROL_TABLE_END_POINT}/update`;
const STORE_STRIKE_SURFACES_END_POINT = `${STRIKE_CONTROL_TABLE_END_POINT}/store`;
const DELETE_STRIKE_SURFACES_END_POINT = `${STRIKE_CONTROL_TABLE_END_POINT}/delete`;
const ADD_EMPTY_STRIKE_ROW_END_POINT = `${STRIKE_CONTROL_TABLE_END_POINT}/add-empty-row`;
const GET_STRIKE_SURFACES_END_POINT = `${STRIKE_CONTROL_TABLE_END_POINT}/get-strike-surfaces`;
const OTHER_VOL_SURFACES_END_POINT = `${VOL_SURFACE_END_POINT}/other-vol-surfaces`;
const OTHER_SURFACE_SET_STRIKES_END_POINT = `${OTHER_VOL_SURFACES_END_POINT}/set-strikes`;
const OTHER_SURFACE_SET_STRIKES_APPLY_END_POINT = `${OTHER_SURFACE_SET_STRIKES_END_POINT}/apply`;

//// DATA TEAM APIs ////
const DATA_TEAM_END_POINT = `${VOL_SURFACE_END_POINT}/data-team`;
const DATA_TEAM_SURFACES_END_POINT = `${DATA_TEAM_END_POINT}/surfaces`;
const DATA_TEAM_EXPORT_DATE_END_POINT = `${DATA_TEAM_END_POINT}/export`;

const UN_LOCK_END_POINT = `unlock-model`;

//// TRADER APIs ////
const UPDATE_TRADER_SURFACE_END_POINT = `/trader/update-shortcut-surface`;
const GET_TRADER_SURFACE_END_POINT = `/trader/get-shortcut-eod-surfaces`;

export const updateTraderSurface = async (body) => {
  return await api.post(UPDATE_TRADER_SURFACE_END_POINT, { ...body });
};

export const getTraderSurface = async (queryParams) => {
  return await api.get(GET_TRADER_SURFACE_END_POINT, { ...queryParams });
};

export const getGraphsData = async (param) => {
  return await api.get(GRAPHS_END_POINT, { ...param });
};

export const getSurface3dData = async (param) => {
  return await api.get(SURFACE_3D_END_POINT, { ...param });
};

export const fetchTrailDataForVolSurface = async (queryParams) => {
  return await api.get(GET_TABLE_ROWS_END_POINT, { ...queryParams });
};

export const batchUpdateGraphs = async (body) => {
  return await api.post(UPDATE_BATCH_END_POINT, { ...body });
};

export const fetchFiltersForVolSurface = async () => {
  return await api.get(GRAPHS_FILTER_END_POINT);
};

export const fetchFilterShortCutsForVolSurface = async (queryParams,signal) => {
  return await api.get(SHORTCUTS_END_POINT, {...queryParams} ,{},signal);
};
export const fetchSurfacesWithSmilesErrors = async (queryParams,signal) => {
  return await api.get(GET_SURFACES_WITH_SMILES_ERRORS_END_POINT, {...queryParams} ,{},signal);
};

export const sendEmailForVolSurface = async (queryParams) => {
  return await api.get(EXPORT_DATE_END_POINT, { ...queryParams });
};

export const fetchUserVolSurface = async (queryParams) => {
  return await api.get(SURFACES_END_POINT, { ...queryParams });
};

export const updateUserVolSurfaceTitle = async (body, isSticky) => {
  // Other Surface Save must always send displayed_points (even []). Omitting the
  // key is treated as an old client and the backend emails URGENT.
  const payload = isSticky
    ? {
        ...body,
        displayed_points: Array.isArray(body?.displayed_points)
          ? body.displayed_points
          : [],
      }
    : body;

  // api.post(url, params, data) — data is the JSON body. Passing the payload as
  // the second arg put it on the query string, so displayed_points never arrived.
  return await api.post(
    isSticky
      ? STORE_STRIKE_CONTROL_TABLE_END_POINT
      : STORE_DELTA_SURFACE_END_POINT,
    {},
    { ...payload }
  );
};

export const setLiveForUserVolSurface = async (body) => {
  return await api.post(SET_LIVE_END_POINT, { ...body });
};

export const updateOnEditCell = async (body) => {
  return await api.post(DELTA_CONTROL_TABLE_END_POINT, {}, { ...body });
};
export const updateOnEditEstimateCell = async (body) => {
  return await api.post(VOL_CALC_TABLE_END_POINT, {}, { ...body });
};

export const getControlTableData = async (param) => {
  return await api.get(DELTA_CONTROL_TABLE_END_POINT, { ...param });
};

export const getVolSurfaceData = async (param) => {
  return await api.get(DATA_TEAM_END_POINT, { ...param });
};

export const getSurfacesData = async (param) => {
  return await api.get(DATA_TEAM_SURFACES_END_POINT, { ...param });
};

export const downloadVolSurfaceData = async (params) => {
  return await api.get(DATA_TEAM_EXPORT_DATE_END_POINT, { ...params });
};

export const getVolSurfaceStickyStrikes = async (queryParams) => {
  return await api.get(
    STRIKE_CONTROL_TABLE_END_POINT,
    buildOtherSurfaceQueryParams(queryParams)
  );
};
export const unlockVolSurfaceStickyStrikes = async (body) => {
  return await api.post(UN_LOCK_END_POINT, {}, { ...body });
};
export const getStrikeSurfaces = async (queryParams) => {
  return await api.get(GET_STRIKE_SURFACES_END_POINT, { ...queryParams });
};

export const getStrikeGraphsData = async (param) => {
  return await api.get(STRIKE_GRAPHS_END_POINT, { ...param });
};

export const updateStickyStrikeCell = async (body) => {
  return await api.post(UPDATE_STRIKE_CONTROL_TABLE_END_POINT, {}, { ...body });
};

export const saveStickyStrikeCell = async (body) => {
  return await api.post(STORE_STRIKE_SURFACES_END_POINT, { ...body });
};

export const deleteRow = async (summary_ids) => {
  return await api.post(DELETE_STRIKE_SURFACES_END_POINT, {}, {
    rows: summary_ids,
  });
};

export const addEmptyStrikeRow = async (body) => {
  return await api.post(ADD_EMPTY_STRIKE_ROW_END_POINT, {}, { ...body });
};

export const getOtherSurfaceSetStrikes = async (productContractStyleId) => {
  return await api.get(
    OTHER_SURFACE_SET_STRIKES_END_POINT,
    buildOtherSurfaceQueryParams({
      product_contract_style_id: productContractStyleId,
    })
  );
};

export const saveOtherSurfaceSetStrikes = async (body) => {
  return await api.put(OTHER_SURFACE_SET_STRIKES_END_POINT, {}, { ...body });
};

export const applyOtherSurfaceSetStrikes = async (body) => {
  return await api.post(
    OTHER_SURFACE_SET_STRIKES_APPLY_END_POINT,
    {},
    { ...body }
  );
};

export const fetchBrokingCompanies = async () => {
  return await api.get(BROKING_COMPANIES_END_POINT);
};

export const fetchTraderShortcuts = async (queryParams) => {
  return await api.get(TRADER_SHORTCUTS_END_POINT, { ...queryParams });
};

export const getLastEodSurfacesForShortcuts = async (queryParams) => {
  return await api.get(GET_LAST_EOD_SURFACES_FOR_SHORTCUTS_END_POINT, {
    ...queryParams,
  });
};

export const sendSftpFile = async (body) => {
  return await api.post(SEND_SFTP_FILE_END_POINT, {}, { ...body });
};

export const fetchVolComparisonShortcuts = async () => {
  return await api.get(VOL_COMPARISON_SHORTCUTS_END_POINT);
};

export const fetchVolComparisonMinAccumulatedQty = async (
  productContractStyleId
) => {
  return await api.get(VOL_COMPARISON_MIN_ACCUMULATED_QTY_END_POINT, {
    product_contract_style_id: productContractStyleId,
  });
};

export const saveVolComparisonMinAccumulatedQty = async (body) => {
  return await api.put(
    VOL_COMPARISON_MIN_ACCUMULATED_QTY_END_POINT,
    {},
    { ...body }
  );
};

export const previewVolComparison = async (body) => {
  return await api.post(VOL_COMPARISON_PREVIEW_END_POINT, {}, { ...body });
};

export const sendVolComparison = async (body) => {
  return await api.post(VOL_COMPARISON_SEND_END_POINT, {}, { ...body });
};

//// FUTURES CURVE APIs ////
const FUTURES_CURVE_END_POINT = `${VOL_SURFACE_END_POINT}/futures-curve`;
const FUTURES_CURVE_PRODUCTS_FILTER_END_POINT = `${DELTA_SURFACES_END_POINT}/filters/products`;
const FUTURES_CURVE_CONTRACTS_FILTER_END_POINT = `${FUTURES_CURVE_END_POINT}/filters/contracts`;
const FUTURES_CURVE_CONTROL_TABLE_END_POINT = `${FUTURES_CURVE_END_POINT}/control-table`;

export const fetchFuturesCurveProducts = async () => {
  return await api.get(FUTURES_CURVE_PRODUCTS_FILTER_END_POINT);
};

export const fetchFuturesCurveContracts = async (productId) => {
  return await api.get(FUTURES_CURVE_CONTRACTS_FILTER_END_POINT, {
    product_id: productId,
  });
};

export const getFuturesCurveControlTable = async (params) => {
  return await api.get(FUTURES_CURVE_CONTROL_TABLE_END_POINT, {
    product_id: params.product_id,
    contract_id: params.contract_id,
  });
};

export const saveFuturesCurveControlTable = async (body) => {
  return await api.post(FUTURES_CURVE_CONTROL_TABLE_END_POINT, {}, { ...body });
};

export {
  GRAPHS_FILTER_END_POINT,
  SHORTCUTS_END_POINT,
  SURFACES_END_POINT,
  GET_STRIKE_SURFACES_END_POINT,
  BROKING_COMPANIES_END_POINT,
  TRADER_SHORTCUTS_END_POINT,
  FUTURES_CURVE_PRODUCTS_FILTER_END_POINT,
  FUTURES_CURVE_CONTRACTS_FILTER_END_POINT,
  FUTURES_CURVE_CONTROL_TABLE_END_POINT,
};